import {useEffect, useState} from 'react';
import {
  subscribeToApiErrors,
  ApiErrorEvent,
} from '@/lib/notifications/apiErrorBus';
import {cn} from '@/lib/utils/cn';

interface Toast extends ApiErrorEvent {
  id: number;
}

const AUTO_DISMISS_MS = 6000;

export function Toaster() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    let nextId = 1;
    return subscribeToApiErrors(detail => {
      const id = nextId++;
      setToasts(prev => [...prev, {...detail, id}]);
      window.setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, AUTO_DISMISS_MS);
    });
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {toasts.map(t => (
        <div
          key={t.id}
          role="alert"
          className={cn(
            'rounded-md border shadow-lg px-4 py-3 text-sm',
            'bg-red-50 border-red-200 text-red-900',
            'dark:bg-red-950 dark:border-red-800 dark:text-red-100'
          )}
        >
          <div className="flex items-start justify-between gap-3">
            <div>
              <div className="font-medium">
                {t.status ? `Error ${t.status}` : 'Network error'}
              </div>
              <div className="opacity-80 mt-0.5">{t.message}</div>
            </div>
            <button
              onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}
              className="opacity-60 hover:opacity-100"
              aria-label="Dismiss"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
